"use client"

import { useTheme } from "next-themes"
import { useSyncExternalStore } from "react"
import { Button } from "@/components/ui/button"
import { Sun, Moon, Monitor } from "lucide-react"

const themes = ["light", "dark", "system"] as const
type Theme = (typeof themes)[number]

const icons: Record<Theme, React.ReactNode> = {
  light: <Sun className="h-4 w-4" />,
  dark: <Moon className="h-4 w-4" />,
  system: <Monitor className="h-4 w-4" />,
}

const labels: Record<Theme, string> = {
  light: "Chiaro",
  dark: "Scuro",
  system: "Auto",
}

// Returns true only on the client after hydration
function useMounted() {
  return useSyncExternalStore(
    (cb) => {
      window.addEventListener("storage", cb)
      return () => window.removeEventListener("storage", cb)
    },
    () => true,
    () => false,
  )
}

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  const mounted = useMounted()

  if (!mounted) {
    return <Button variant="ghost" size="icon" className="w-9 h-9" disabled />
  }

  const current = (theme as Theme) ?? "system"
  const next = themes[(themes.indexOf(current) + 1) % themes.length]

  return (
    <Button
      variant="ghost"
      size="icon"
      className="w-9 h-9"
      onClick={() => setTheme(next)}
      title={`Tema: ${labels[current]} → passa a ${labels[next]}`}
    >
      {icons[current]}
      <span className="sr-only">{labels[current]}</span>
    </Button>
  )
}
